/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Link } from 'gatsby'

import Form from '~/components/peoplevineForm'

function Footer() {
  return (
    <footer>
      <div className="page-wrap mt3 bpS-mt0 bps-p100 display-flex fw-w">
        <div className="width-100 bpS-width-50 display-flex fw-w bpS-fw-nw">
          <div sx={{ width: 200 }}>
            <a
              href="https://members.planque.co.uk/"
              className=""
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                fill="none"
                viewBox="0 0 44 44"
              >
                <path
                  fill="#000"
                  d="M22 7a7 7 0 0 1 2.58 13.507L29 37H15.177l4.402-16.43A7.002 7.002 0 0 1 22 7"
                />
              </svg>
            </a>

            <div className="mt1">
              <div style={{ display: 'none' }}>
                <Link to="/terms" className="link link-underline">
                  Terms
                </Link>
              </div>
              <div>
                <Link to="/faqs" className="link link-underline">
                  FAQs
                </Link>
              </div>
            </div>
          </div>
          <div className="width-100" sx={{ mt: [20, 0] }}>
            <h4 className="fw-400">Opening Hours</h4>
            <div className="mt1">
              <div
                sx={{
                  display: 'grid',
                  gridTemplateColumns: ['1fr', '1fr', '1fr', '1fr 1fr'],
                  gridGap: '10px'
                }}
              >
                <div>
                  Dinner
                  <br />
                  Tuesday - Saturday: from 6pm
                </div>
                <div>
                  Lunch
                  <br />
                  Saturday: from 12pm
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="width-100 bpS-width-50">
          <h4 className="fw-400 mt1 bpS-mt0">Contact</h4>
          <div className="mt1">
            <div>
              <a
                href="mailto:hello@planque.co.uk"
                className="link link-underline"
              >
                Email
              </a>
            </div>
            <div>
              <a
                href="https://api.whatsapp.com/message/2AXIC7TYMCPJG1"
                target="_blank"
                className="link link-underline"
              >
                Message
              </a>
            </div>
            <div>
              <a
                href="https://squareup.com/gift/MLJP0JSYHM240/order"
                target="_blank"
                className="link link-underline"
              >
                Gift Cards
              </a>
            </div>
            <div>
              <div className="display-flex fw-w bpS-fw-nw">
                <div className="width-100 bpS-width-50">
                  <div>Subscribe to our newsletter</div>
                </div>
                <div className="width-100 bpS-width-50 mt1 bpS-mt0">
                  <Form />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
